import React, { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import { CToast, CToastBody, CToastHeader, CToaster } from "@coreui/react";
import toastStore from "../../../store/ToastStore";

const AppToaster = observer(() => {
  const [pushElement, setPushElement] = useState(null);
  const lastIdRef = useRef(0);

  useEffect(() => {
    const latest = toastStore.toasts[toastStore.toasts.length - 1];
    if (!latest || latest.id === lastIdRef.current) return;
    lastIdRef.current = latest.id;
    const hasAutohide = latest.autohide !== false;
    setPushElement(
      <CToast
        autohide={hasAutohide}
        delay={typeof latest.autohide === "number" ? latest.autohide : 5000}
        color={latest.color}
        className="text-white align-items-center"
      >
        {latest.title && <CToastHeader closeButton>{latest.title}</CToastHeader>}
        <div className="d-flex">
          <CToastBody>{latest.message}</CToastBody>
        </div>
      </CToast>,
    );
  }, [toastStore.toasts.length]);

  return <CToaster placement="top-end" push={pushElement} className="p-3" />;
});

export default AppToaster;
